<app-edtell-front-facing-dialog [config]="dialogConfig">
    <div class="row">
        <div class="col-12">
            <p>
                It appears there is another registration in progress that belongs to a different program. Would you like to start a new registration?
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <app-edtell-button class="mr-2" [config]="continueRegConfig"></app-edtell-button>
            <app-edtell-button [config]="goBackConfig"></app-edtell-button>
        </div>
    </div>
</app-edtell-front-facing-dialog>